<template>
	<v-card v-if="item">
		<v-card-title>
			<v-chip v-if="item.status == 0 && item.message.length > 0 && !item.deletedAt" label color="teal accent-2" text-color="black">
				<v-icon left>question_answer</v-icon>DISCUSSING
			</v-chip>
			<v-chip v-if="item.status == 0 && item.message.length == 0" label color="orange lighten-3" text-color="black">
				<v-icon left>hourglass_full</v-icon>WAIT FOR EDIT
			</v-chip>
			<v-chip v-if="item.status == 1" label color="yellow lighten-3" text-color="black">
				<v-icon left>assignment_turned_in</v-icon>EDITED
			</v-chip>
			<v-chip v-if="item.status == 2" label color="green lighten-1" text-color="black">
				<v-icon left>done</v-icon>APPROVED
			</v-chip>
			<v-chip v-if="item.status == 0 && item.deletedAt && isUnpublished" label color="grey lighten-1" text-color="black">
				<v-icon left>delete_forever</v-icon>UNPUBLISHED
			</v-chip>
			<v-chip v-if="item.status == 0 && item.deletedAt && !isUnpublished" label color="grey lighten-1" text-color="black">
				<v-icon left>delete_forever</v-icon>REMOVED
			</v-chip>

			<v-spacer></v-spacer>

			<p class="text-xs-right" color="grey lighten-2">Suspended By <strong v-html="item.admin.username"></strong><br><small v-html="item.createdAt"></small></p>
		</v-card-title>
		<v-card-text class="pt-0 pb-0">
			<template v-if="item.contentType == 'COMMENT'">
			    <v-card class="comment-card" @click="handlePreview" :class="{'is-unpublished': isUnpublished}">
			        <v-layout>
			            <v-flex class="content-info px-3 pt-1 pb-3">
			                <div class="title"><v-chip class="ml-0 mr-2 mb-3" small>{{ item.contentType }} - {{ item.contentId }}</v-chip></div>

							<template v-for="block in item.content.blocks">
								<template v-if="block.blockType == 'TEXT'">
									<p class="py-3 mb-0" v-if="block.blockType == 'TEXT'" v-html="block.data.contentText"></p>
								</template>
								<template v-else-if="block.blockType == 'IMAGE'">
									<v-img v-for="(image, n) in block.data" :key="image.id" contain :src="`https://www.jeban.com${image.imageSrc.replace('http://s.jeban.com', '').replace('http://www.jeban.com', '').replace('https://www.jeban.com', '')}`" max-height="150"></v-img>
								</template>
								<template v-else-if="block.blockType == 'STICKER'">
									<v-img contain :src="block.data.sticker.stickerUrl" max-height="100"></v-img>
								</template>
							</template>

							<p class="body-2 created-by mb-0 mt-5">
						  		<a @click.stop="handleRequesterClick" :href="`https://www.jeban.com/mypage/${item.user.id}`" target="_blank">{{ item.user.username }}</a>
						  		<small>, {{ item.content.publishedOn }}</small>
							</p>
			            </v-flex>
			        </v-layout>
			    </v-card>
			</template>
			<template v-else>
			    <v-card class="content-card" @click="handlePreview" :class="{'is-unpublished': isUnpublished}">
			        <v-layout>
			            <v-flex xs3 class="cover">
			                <v-img :src="contentCover" height="150px" aspect-ratio="1"></v-img>
			            </v-flex>
			            <v-flex class="content-info px-3 pt-1 pb-3" xs9>
			                <div class="title"><v-chip class="ml-0 mr-2 mb-3" small>{{ contentCode }}<span style="font-weight: 400; font-size: 85%;" v-if="isUnpublished">&nbsp;-&nbsp;Unpublished</span></v-chip><br>{{ contentTitle }}</div>
							<p class="body-2 created-by mb-0">
						  		<a @click.stop="handleRequesterClick" :href="`https://www.jeban.com/mypage/${item.user.id}`" target="_blank">{{ item.user.username }}</a>
						  		<small>, {{ item.content.publishedOn }}</small>
							</p>
			            </v-flex>
			        </v-layout>
			    </v-card>
			</template>

			<v-timeline class="conversation-log" dense align-top>
			    <v-timeline-item hide-dot>
			        <h3>Message</h3>
			    </v-timeline-item>

			    <v-timeline-item class="mb-2">
					<template v-slot:icon>
						<v-avatar>
							<v-img :src="item.admin.avatar"></v-img>
						</v-avatar>
					</template>
					<v-card color="red lighten-2" class="elevation-3" dark>
						<v-card-title>
							<v-icon dark class="mr-2">gavel</v-icon>
							<strong>เหตุผล</strong>
						</v-card-title>
						<v-card-text class="white text--primary">
							<p class="subtitle-1 mb-0">{{item.reason }}</p>
					    </v-card-text>
					</v-card>
					<v-subheader class="pl-0"><span v-html="item.admin.username"></span><v-spacer></v-spacer><small v-html="item.createdAt"></small></v-subheader>
			    </v-timeline-item>

				<template v-for="(message, index) in item.message">
				    <v-timeline-item color="warning" icon="assignment_turned_in" fill-dot small v-if="message.message == '[แจ้งแก้ไขแล้ว]'">
				    	<v-alert :value="true" color="yellow lighten-3" class="py-0 mb-4">
				    		<v-subheader class="pl-0"><span>EDITED</span><v-spacer></v-spacer><small v-html="message.createdAt"></small></v-subheader>
	            		</v-alert>
				    </v-timeline-item>
				    <v-timeline-item class="mb-2" v-else>
						<template v-slot:icon>
							<v-avatar>
								<v-img :src="message.user.avatar"></v-img>
							</v-avatar>
						</template>
						<template v-slot:opposite>
							<p class="mb-0">{{ message.user.username }}<br>{{ message.createdAt }}</p>
						</template>					
						<v-card class="elevation-1">
							<v-card-text>
								<p class="subtitle-1 mb-0">{{ message.message }}</p>
						    </v-card-text>
						</v-card>
						<v-subheader class="pl-0"><span v-html="message.user.username"></span><v-spacer></v-spacer><small v-html="message.createdAt"></small></v-subheader>
				    </v-timeline-item>
			    </template>

			    <v-timeline-item color="warning" icon="assignment_turned_in" fill-dot small v-if="item.status == 1 && !item.message.length">
			    	<v-alert :value="true" color="yellow lighten-3" class="py-0">
			    		<v-subheader class="pl-0"><span>EDITED</span><v-spacer></v-spacer><small v-html="item.updatedAt"></small></v-subheader>
            		</v-alert>
			    </v-timeline-item>

			    <v-timeline-item color="green lighten-1" icon="done" dark fill-dot small v-if="item.status == 2">
			    	<v-alert :value="true" color="success" class="white--text py-0">
			    		<v-subheader class="pl-0"><span>APPROVED</span><v-spacer></v-spacer><small v-html="item.updatedAt"></small></v-subheader>
            		</v-alert>
			    </v-timeline-item>
			    <v-timeline-item fill-dot class="white--text mb-1" color="grey lighten-3" large v-else>
					<template v-slot:icon>
						<v-avatar>
							<v-img :src="user.avatar"></v-img>
						</v-avatar>
					</template>
			        <v-text-field v-model="message" class="pr-0 message-box" hide-details flat label="ส่งข้อความตอบกลับ..." solo @keyup.enter="handleSendMessage">
			            <template v-slot:append>
			                <v-btn class="mx-0" color="primary" depressed @click="handleSendMessage">
			                    Post
			                </v-btn>
			            </template>
			        </v-text-field>
			    </v-timeline-item>

				<v-btn @click="handleApprove" v-if="item.status == 0 && !item.deletedAt">
					<v-icon left>restore</v-icon>
					UNDO SUSPEND
				</v-btn>
				<v-btn color="success" @click="handleApprove" v-if="item.status == 1 && !item.deletedAt">
					<v-icon left dark>check</v-icon>
					APPROVE
				</v-btn>
				<v-btn @click="handleUnpublish" color="red lighten-2" v-if="item.status != 2 && !item.deletedAt" flat>
					<v-icon left>delete</v-icon>
					UNPUBLISH CONTENT
				</v-btn>

			</v-timeline>
		</v-card-text>

		<v-card-actions class="px-3" v-if="item.status != 2">			
			<v-spacer></v-spacer>
			<v-btn flat color="red" @click="handleDelete" v-if="!item.deletedAt">
				<v-icon left light>delete</v-icon>
				DELETE
			</v-btn>
			<v-btn @click="handleRestore" v-if="item.status != 2 && item.deletedAt">
				<v-icon left light>restore_from_trash</v-icon>
				RECOVER
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import {authMixins} from '@/mixins/auth'

	export default {
		mixins: [authMixins],
		props: ['item'],
		data () {
			return {
				message: ''
			}
		},
		computed: {
			isUnpublished () 
			{
				if (typeof this.item === 'undefined') {
					return true
				} else if (typeof this.item.content !== 'undefined') {
					if (this.item.content) {
						return !(this.item.content.published)
					} else {
						return false
					}
				} else {
					return true
				}
			},
			alertColor () 
			{
				return (this.isUnpublished) ? "grey lighten-2" : ((!this.item.reviewed) ? "grey lighten-4" : "green lighten-4")
			},
			contentText () 
			{
				try {
					return this.item.content.blocks.filter(b => b.blockType == 'TEXT')[0].data.contentText
				} catch (error) {
					// console.log(error)
				}
				
			},
			contentTitle () 
			{
				return (this.item.contentType == 'COMMENT') ? this.contentText : this.item.content.title
			},
			contentCover ()
			{
				return `https://www.jeban.com${this.item.content.coverUrl.replace('http://s.jeban.com', '').replace('http://www.jeban.com', '').replace('https://www.jeban.com', '')}`
			},
			contentKeys ()
			{
				return (this.item) ? {contentType: this.item.contentType, contentId: this.item.contentId, userId: this.item.admin.id} : {}
			},
			contentCode ()
			{
				return (this.item.contentType == 'TOPIC') 
					? `${this.item.contentType}-${this.item.contentId} (${this.item.content.type})`
					: `${this.item.contentType}-${this.item.contentId}`
			}
		},
		methods: {
			handlePreview ()
			{
				this.$emit('preview', this.contentKeys)
				// this.$emit('preview', {contentType: 'TOPIC', contentId: 270268})				
			},
			handleRequesterClick () 
			{

			},
			handleApprove () {
				this.$emit('approve', this.contentKeys)
			},
			handleDelete () 
			{
				this.$emit('delete', { id: this.item.id, keys: this.contentKeys })
			},
			handleRestore ()
			{
				this.$emit('restore', this.item.id)
			},
			handleUnpublish ()
			{
				this.$emit('unpublish', { id: this.item.id, keys: this.contentKeys })
			},
			handleSendMessage (message)
			{
				this.$emit('send-message', { id: this.item.id, message: this.message })
				this.message = ''
			}
		}
	}
</script>

<style lang="scss">
	.is-unpublished {
		opacity: .54;
	}
	.content-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: calc(100% - 168px);
		font-weight: normal;
	}
	.v-alert {
		border-radius: 4px;
		color: #616161;
	}
	.created-by {
		color: #757575;
		a {
			color: inherit !important;
			font-weight: bold;
		}
	}

	.content-card,
	.comment-card {
		.cover {
			background: #EEEEEE;
		}
		.content-info {
		    display: flex;
		    flex-flow: column;
		    justify-content: space-between;			
		}
	}
	.comment-card {
		max-width: 640px;
		margin-left: auto;
		margin-right: auto;
	}

	.content-card {
		max-width: 800px;
		margin-left: auto;
		margin-right: auto;
	}

	.conversation-log {
		max-width: 640px;
		margin-left: auto;
		margin-right: auto;
	}

	.message-box {
		border: 1px solid #E0E0E0;
	}
</style>
